/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GlobalMappingSettingsAddSpacesToCamelCase$Params {
  input?: string | null;
}

export function globalMappingSettingsAddSpacesToCamelCase(http: HttpClient, rootUrl: string, params?: GlobalMappingSettingsAddSpacesToCamelCase$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, globalMappingSettingsAddSpacesToCamelCase.PATH, 'get');
  if (params) {
    rb.query('input', params.input, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

globalMappingSettingsAddSpacesToCamelCase.PATH = '/api/GlobalMappingSettings';
